import Marionette from "../../shared/marionette-mustache";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { Container } from "aurelia-dependency-injection";
import { ContainerHelper } from "../../shared/helpers/container-helper";

require("../../desktop/styles/statute-outline.less");
const template = require<string>("./statute-outline.html");

@backboneViewProperties({
    tagName: "div",
    className: "statute-outline-region statute-outline",
    template
})
export class StatuteOutlineView extends Marionette.ItemView<Backbone.Model> {
    public appEvents: Backbone.Events;

    constructor(options?: Backbone.ViewOptions<Backbone.Model>) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public onShow() {
        // specify child views here
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {
            "click .statute-outline-link": (e) => this.onclickViewActOutline(e)
        };
        return events;
    }

    public onclickViewActOutline(e) {
        e.preventDefault();
        const t = $(e.currentTarget);
        this.appEvents.trigger(AppEvents.ViewStatuteOutline, t.prop("pathname"));
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/statute-outline.ts